import TicketTypeIcon from "app/components/TicketTypeIcon";
import CustomTooltip from "app/components/Tooltip";
import { getTicketTypeByIds } from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/helper";
import { selectTicketTypes } from "app/redux/selector";
import clsx from "clsx";
import { useQueryState } from "nuqs";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectDraftBoardForm } from "../../../../components/Settings/redux/selector";
import { GroupByTypeEnum } from "../../../../types";
import TicketActions from "../../../Home/components/TicketActions";
import TagSelection from "../../TicketFields/RowCustomize/TagSelection";
import { useTicketFieldUpdate } from "../../TicketFields/useTicketFieldUpdate";
import RowActions from "./RowActions";
import { RowFirstColProps } from "./types";
import ArchiveModalWrapper from "app/containers/Features/components/ArchiveModalWrapper";
import { ArchiveType } from "app/types";
import { actions } from "app/redux/slice";
import { ticketGroupsActions } from "../../redux/slice";
import { useParams } from "react-router-dom";

const RowFirstCol: React.FC<RowFirstColProps> = ({
  isSelected,
  onCheckboxClick,
  ticket,
  projectId,
}) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const [isEdit, setIsEdit] = useState(false);
  const [tid, setTid] = useQueryState("tid");
  const { handleUpdate } = useTicketFieldUpdate(ticket._id, projectId);
  const boardData = useSelector(selectDraftBoardForm);
  const ticketTypes = useSelector(selectTicketTypes);
  const { project } = useParams();
  const dispatch = useDispatch();
  const [showActions, setShowActions] = React.useState(false);
  const [showArchive, setShowArchive] = React.useState(false);

  const handleArchive = () => {
    dispatch(
      actions.doArchive({
        projectId: project || "",
        dataId: [ticket._id || ""],
        dataType: ArchiveType.TICKET,
        callback() {},
      }),
    );
    // is use for remove ticket from local group
    dispatch(
      ticketGroupsActions.removeTicketLocally({ ticketIds: ticket._id }),
    );

    setShowArchive(false);
  };

  const showTags = boardData?.customizeCards?.some(
    (x) => x.type === GroupByTypeEnum.TAGS && x.isVisible,
  );
  const showTicketID = boardData?.customizeCards?.some(
    (x) => x.type === GroupByTypeEnum.TICKET_ID && x.isVisible,
  );
  const showTicketType = boardData?.customizeCards?.some(
    (x) => x.type === GroupByTypeEnum.TICKET_TYPE && x.isVisible,
  );
  const ticketType = useMemo(() => {
    return getTicketTypeByIds(ticketTypes, ticket.type)[0];
  }, [ticketTypes, ticket.type]);

  return (
    <>
      <div
        className={clsx(
          "flex items-center gap-2 min-w-0 sticky left-[62px] z-10  h-full group-hover:bg-gray-200 relative  ",
          isSelected ? "!bg-[#E7F1FF] " : "bg-white",
        )}
      >
        <RowActions
          ticket={ticket}
          isSelected={isSelected}
          onCheckboxClick={onCheckboxClick}
          onArchive={() => {
            setShowArchive(true);
          }}
          onDuplicate={() => {
            dispatch(
              ticketGroupsActions.duplicateTicketLocally({
                ticketIds: ticket._id,
              }),
            );
          }}
          projectId={projectId}
          setShowActions={setShowActions}
          showActions={showActions}
        />

        <div
          className={clsx(
            "flex flex-row items-center gap-[4px] relative w-full px-[4px] rounded-sm h-full min-w-0 overflow-hidden",
            isEdit && "border border-secondary",
            !isEdit && "hover:border hover:border-gray-300",
          )}
          ref={ref}
        >
          {showTicketType && (
            <div className="flex-shrink-0">
              <TicketTypeIcon iconName={ticketType?.icon as string} size={20} />
            </div>
          )}
          <div
            className="flex flex-row items-center gap-[4px] relative min-w-0 shrink overflow-hidden"
            onClick={(e) => {
              e.stopPropagation();
              setTid(ticket?._id);
            }}
          >
            {showTicketID && (
              <span className="text-sm leading-[18px] font-normal text-black shrink-0 whitespace-nowrap">
                {ticket?.ticketID}
              </span>
            )}
            <CustomTooltip
              text={ticket?.ticketName || ""}
              contentClassName="max-w-[443px] break-words  "
              position="bottom"
              className="min-w-0 shrink max-w-full"
            >
              <div className="text-sm leading-[18px] font-normal text-black text-ellipsis overflow-hidden whitespace-nowrap min-w-0 max-w-full cursor-pointer">
                {ticket?.ticketName}
              </div>
            </CustomTooltip>
          </div>
          <div className="flex flex-row items-center gap-[4px] flex-shrink-0 min-w-0 overflow-hidden">
            <TicketActions ticket={ticket} status={ticket.status} />
          </div>
          {showTags && (
            <div className="shrink-0">
              <TagSelection
                tagIds={ticket.tags}
                onUpdate={(tags, action) => {
                  handleUpdate(GroupByTypeEnum.TAGS, tags, action);
                }}
              />
            </div>
          )}
        </div>
      </div>
      {showArchive && (
        <ArchiveModalWrapper
          onClose={() => setShowArchive(false)}
          content={`Are you sure that you want to archive <span class=" !font-medium">${ticket?.ticketName}</span>?`}
          onSave={() => {
            handleArchive();
          }}
          title="Archive ticket"
          backButtonText="Revert"
        />
      )}
    </>
  );
};

export default RowFirstCol;
